module.exports = __webpack_public_path__ + "img/Gebäude.e089a522.svg";